import type { TypographyOptions } from '@mui/material/styles/createTypography';

import { colors, fontFamily, fontSize, fontWeight, lineHeight } from '../../tokens';

/**
 * VDS typography — maps core typography tokens onto MUI variant slots.
 * This is Tier 2: semantic mapping. Do not reference raw values here.
 */
export const typographyFigmaThemeConfig: TypographyOptions = {
  fontSize: fontSize[16],
  fontFamily: `${fontFamily.primary}, ${fontFamily.fallback}`,
  htmlFontSize: 10,

  body1: {
    fontSize: `${fontSize[16]}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.body1}%`,
    letterSpacing: '0.15px',
  },
  body2: {
    fontSize: `${fontSize[14]}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.body2}%`,
    letterSpacing: '0.17px',
  },
  subtitle1: {
    fontSize: `${fontSize[16]}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.subtitle1}%`,
    letterSpacing: '0.15px',
  },
  subtitle2: {
    fontSize: `${fontSize[14]}px`,
    fontWeight: fontWeight.medium,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.subtitle2}%`,
    letterSpacing: '0.1px',
  },
  overline: {
    fontSize: `${fontSize[12]}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.overline}%`,
    letterSpacing: '1px',
    textTransform: 'uppercase',
  },
  caption: {
    fontSize: `${fontSize[12]}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.caption}%`,
    letterSpacing: '0.15px',
  },
  h1: {
    fontSize: `${fontSize[96]}px`,
    fontWeight: fontWeight.light,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.h1}%`,
    letterSpacing: '-1.5px',
  },
  h2: {
    fontSize: `${fontSize[60]}px`,
    fontWeight: fontWeight.light,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.h2}%`,
    letterSpacing: '-0.5px',
  },
  h3: {
    fontSize: `${fontSize[48]}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.h3}%`,
  },
  h4: {
    fontSize: `${fontSize[34]}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.h4}%`,
    letterSpacing: '0.25px',
  },
  h5: {
    fontSize: `${fontSize[24]}px`,
    fontWeight: fontWeight.regular,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.h5}%`,
  },
  h6: {
    fontSize: `${fontSize[20]}px`,
    fontWeight: fontWeight.medium,
    fontStyle: 'normal',
    color: colors['neutral-900'],
    lineHeight: `${lineHeight.h6}%`,
    letterSpacing: '0.15px',
  },
};
